export default {
  header: {
    title: 'All Dispatches',
    newDispatch: 'New Dispatch',
    dashboard: 'Dashboard',
    management: 'Management',
    dispatches: 'Dispatches',
    clock: {
      usButton: 'US',
      mexicoButton: 'Mexico',
      canadaButton: 'Canada',
      yourTimeZone: 'Your Time Zone',
      pacific: 'Pacific',
      mountain: 'Mountain',
      central: 'Central',
      eastern: 'Eastern',
      arizona: 'Arizona',
      alaska: 'Alaska',
      hawaii: 'Hawaii',
      atlantic: 'Atlantic',
      newfoundland: 'Newfoundland'
    }
  },
  filters: {
    searchDispatches: 'Search dispatches',
    sortBy: 'Sort By',
    clients: 'Clientes',
    lastUpdateNewest: 'Last update (newest first)',
    lastUpdateOldest: 'Last update (oldest first)',
    openOnly: 'Open Only',
    dispatchStatus: 'Dispatch Status',
    dispatchState: 'Dispatch State',
    type: 'Type',
    noAssignedProvider: 'No Assigned Provider',
    refreshDispatchList: 'Refresh Dispatch List',
    approachingETA: 'Acercándose a ETA',
    late: 'Tarde',
    onTime: 'A tiempo',
    needsApproval: 'Necesita aprobación',
    needsCancelApproval: 'Necesita cancelar aprobación',
    statuses: {
      Accepted: 'Accepted',
      'In Route': 'In Route',
      'On Scene': 'On Scene',
      'Tow In Progress': 'Tow In Progress',
      'Destination Arrival': 'Destination Arrival',
      Complete: 'Complete',
      New: 'New',
      Cancelled: 'Cancelled',
      GOA: 'GOA'
    },
    states: {
      'Provider on the way': 'Provider on the way',
      'Provider on site': 'Provider on site',
      'Provider at Drop off': 'Provider at Drop off',
      'Provider En-route to Drop off': 'Provider En-route to Drop off',
      'Provider Completed': 'Provider Completed',
      'Provider Accepted': 'Provider Accepted',
      'Dispatch created': 'Dispatch created',
      'Driver Assigned': 'Driver Assigned',
      'Provider Cancelled': 'Provider Cancelled',
      'Customer Cancelled': 'Customer Cancelled',
      'Customer or vehicle not at Pick Up': 'Customer or vehicle not at Pick Up',
      'Searching For Providers': 'Búsqueda de proveedores',
      'Processing Auto Dispatch': 'Procesamiento de envío automático',
      'Awaiting Manual Dispatch': 'En espera de envío manual',
    },
    types: {
      all: 'All',
      onDemand: 'On Demand',
      scheduled: 'Scheduled',
      approvalRequired: 'Aprobación requerida',
      outOfNetwork: 'Fuera de la red',
      secondary: 'Secundario',
    }
  },
  grid: {
    columns: {
      dispatchCustomer: 'Despacho / Cliente',
      dispatchDate: 'Fecha de despacho',
      service: 'Servicio',
      locations: 'Ubicaciones',
      providerDriver: 'Proveedor',
      actions: 'Acciones',
      clientNameAndDispatchId: 'Cliente / ID de despacho',
      motoristNameAndPhone: 'Nombre del automovilista / Teléfono',
      created: 'Creado',
      eta: 'ETA / Asignado',
      timeStatus: 'Estado de tiempo',
      serviceType: 'Tipo de servicio',
      statusState: 'Estado / Situación',
      csrAssigned: 'CSR asignado',
      providerAssigned: 'Proveedor asignado',
      callDetails: 'Detalles de la llamada',
    }
  }
};
